/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_New_ListingInputs */

const en_nav_new_listing = /** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Listing`)
};

const id_nav_new_listing = /** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Baru`)
};

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const es_nav_new_listing = en_nav_new_listing;

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const fr_nav_new_listing = en_nav_new_listing;

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const de_nav_new_listing = en_nav_new_listing;

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const ja_nav_new_listing = en_nav_new_listing;

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const zh_nav_new_listing = en_nav_new_listing;

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const ar_nav_new_listing = en_nav_new_listing;

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const it_nav_new_listing = en_nav_new_listing;

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const ru_nav_new_listing = en_nav_new_listing;

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const pt_nav_new_listing = en_nav_new_listing;

/** @type {(inputs: Nav_New_ListingInputs) => LocalizedString} */
const ko_nav_new_listing = en_nav_new_listing;

/**
* | output |
* | --- |
* | "New Listing" |
*
* @param {Nav_New_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_new_listing = /** @type {((inputs?: Nav_New_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_New_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_new_listing(inputs)
	if (locale === "es") return es_nav_new_listing(inputs)
	if (locale === "fr") return fr_nav_new_listing(inputs)
	if (locale === "de") return de_nav_new_listing(inputs)
	if (locale === "ja") return ja_nav_new_listing(inputs)
	if (locale === "zh") return zh_nav_new_listing(inputs)
	if (locale === "ar") return ar_nav_new_listing(inputs)
	if (locale === "id") return id_nav_new_listing(inputs)
	if (locale === "it") return it_nav_new_listing(inputs)
	if (locale === "ru") return ru_nav_new_listing(inputs)
	if (locale === "pt") return pt_nav_new_listing(inputs)
	return ko_nav_new_listing(inputs)
});